import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { userId } from '../../../reducers/currentUser/currentUser.reducer';
import { loadForForeman, sortByDate, sortByProjectName } from '../../../reducers/workOrder/workOrders.actions';
import { loading, draftWorkOrders } from '../../../reducers/workOrder/workOrders.reducer';
import { Spinner } from '../../Spinner/Spinner';
import WorkOrderList from '../../WorkOrderList/WorkOrderList';
import './ForemanHome.css';

// eslint-disable-next-line object-curly-newline
export class ForemanHome extends React.Component {
  componentDidMount() {
    this.props.load(this.props.id);
  }

  render() {
    return (
      <span>
        <Button onClick={() => this.props.sortDate()}>Sort Date</Button> &nbsp;&nbsp;&nbsp;
        <Button onClick={() => this.props.sortProject()}>Sort Project</Button>
        <LinkContainer to="/foreman/workorders/new" >
          <Button className="pull-right" bsStyle="primary" >Create New DWR</Button>
        </LinkContainer>
        <br />
        {this.props.loading && <Spinner isLoading /> }
        <WorkOrderList workOrders={this.props.workOrders} url="/foreman" />
      </span>
    );
  }
}

ForemanHome.propTypes = {
  load: PropTypes.func.isRequired,
  sortDate: PropTypes.func.isRequired,
  sortProject: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  workOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
};

export const mapStateToProps = state => ({
  workOrders: draftWorkOrders(state),
  loading: loading(state),
  id: userId(state),
});

export const mapDispatchToProps = dispatch => ({
  load: id => dispatch(loadForForeman(id)),
  sortDate: () => dispatch(sortByDate()),
  sortProject: () => dispatch(sortByProjectName()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForemanHome);



// WEBPACK FOOTER //
// ./src/components/Foreman/Home/ForemanHome.jsx